import createVueComponent from '../createVueComponent';

const Clock10 = createVueComponent('Clock10Icon', [
  ['circle', { cx: '12', cy: '12', r: '10', key: '1mglay' }],
  ['polyline', { points: '12 6 12 12 8 10', key: 'atfzqc' }],
]);

export default Clock10;
